import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function bulkRelateReducer(state = initialstate.bulkRelate, action) {
	switch (action.type) {
		case types.SAVE_UPLOAD_DOCUMENT_ID: {
			const {documentId} = action;

			if (Array.isArray(state.uploadDocumentIds)) {
				if (state.uploadDocumentIds.includes(documentId)) {
					return state;
				}

				return {
					...state,
					uploadDocumentIds: [...state.uploadDocumentIds, documentId]
				};
			}

			return {
				...state,
				uploadDocumentIds: [documentId]
			};
		}

		case types.CLEAR_UPLOAD_DOCUMENT_ID: {
			return {
				...state,
				uploadDocumentIds: []
			};
		}

		case types.SAVE_UPLOAD_DOCUMENTS: {
			return {
				...state,
				uploadDocuments: action.documents
			};
		}

		case types.UPDATE_UPLOAD_DOCUMENT: {
			if (Array.isArray(state.uploadDocuments)) {
				const uploadDocuments = state.uploadDocuments.map((document) => {
					if (action.document.name === document.name) {
						return action.document;
					}

					return document;
				});

				return {
					...state,
					uploadDocuments
				};
			}

			return state;
		}

		case types.CLEAR_UPLOAD_DOCUMENTS: {
			return {
				...state,
				uploadDocuments: []
			};
		}

		case types.REMOVE_TASK_DOCUMENT:
		case types.REMOVE_UPLOAD_DOCUMENT: {
			if (Array.isArray(state.uploadDocuments)) {
				const uploadDocuments = state.uploadDocuments.filter((document) => {
					return action.documentName !== document.name;
				});

				return {
					...state,
					uploadDocuments
				};
			}

			return state;
		}

		default:
			return state;
	}
}
